import TashDashboard from './components/TashDashboard';


function App() {
  

  return (
    <>
    <TashDashboard/>
    </>
  );
}

export default App;
